// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@werner/App/Components/Common/XngLoadingOverlayUtilities";
import { mobileTippyStyle } from "@werner/App/Components/Tippy/Style";
import typography from "@werner/XDL/PreStyle/typography";
import { xBaseTheme } from "@werner/XDL/types";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${hideLoadingOverlay}
        ${xngLoadingOverlayUtilitiesStyles}
        ${mobileTippyStyle}

        // This style to fix an issue with Google Places autocomplete
        .pac-container {
            z-index: 10000 !important;
        }

        .bold {
            font-weight: 500;
        }
        .color-support-01 {
            color: ${color("danger")};
        }
        @media print {
            #lhnHelpOutCenter,
            #lhnHocButton {
                display: none !important;
            }
            h1 {
                font-size: ${typography.h1.size} !important;
            }
            body {
                font-size: ${typography.body.size} !important;
            }
        }
        .xng-table {
            width: 100%;
            border-collapse: collapse;
            td {
                padding: 12px 8px;
                height: 54px;
                border-bottom: 0;
                max-width: 375px;
                min-width: 60px;
            }
            > tbody tr {
                background: transparent;
                border-bottom: 1px solid ${color("common.ui1", 0.65)};
            }
            > thead {
                tr {
                    background: transparent;
                    border-bottom: 1px solid ${color("common.ui1", 0.75)};
                    border-top: 3px solid ${color("common.ui1", 0.75)};
                    th {
                        background: transparent;
                        padding: 12px 8px;
                        height: 44px;
                        border-bottom: 0;
                        text-align: left;
                    }
                }
            }
        }
        .st-image-share-buttons {
            z-index: 1 !important;
        }               
    `,
} as xBaseTheme["globalStyle"];
